import { render, staticRenderFns } from "./ProductFormInfo.vue?vue&type=template&id=1c167372&"
import script from "./ProductFormInfo.vue?vue&type=script&lang=js&"
export * from "./ProductFormInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports